const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;

export const getUrl = async ({id, type, urlType}) => {
    console.log(`Fetching ${urlType} for ${type} ID: ${id}`);
    try {
        const response = await fetch(`${API_BASE_URL}/get_url`, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({id, type, urlType}),})
        if (!response.ok) {
            throw new Error(`Error fetching contact: ${response.statusText}`);
        
        }
        const data = await response.json();

        if (data.url) {
            window.open(data.url, "_blank");
        } else {
            console.error("No website URL available for this contact");
        }
    } catch (error) {
    console.error("Failed to fetch the website URL:", error);
    }
}
 
